import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Search, FileText, CheckCircle, Diamond } from "lucide-react";
import { Button } from "@/components/ui/button";

const STEPS = [
  { icon: Search, num: "01", title: "Explorez et sélectionnez", desc: "Parcourez notre catalogue privé d'artistes internationaux classés par continent, genre et style. Trouvez la personnalité idéale pour votre événement." },
  { icon: FileText, num: "02", title: "Envoyez votre demande", desc: "Remplissez le questionnaire détaillé : type d'événement, date souhaitée, lieu, nombre d'invités, contraintes logistiques et budget estimé." },
  { icon: CheckCircle, num: "03", title: "Validation par l'artiste", desc: "L'artiste et son management étudient votre demande, confirment leur disponibilité et vous transmettent un devis personnalisé." },
  { icon: Diamond, num: "04", title: "Vivez un moment exclusif", desc: "Finalisez la réservation et profitez d'une prestation mémorable. L'équipe MYSE vous accompagne de A à Z." },
];

export default function HowItWorks() {
  const navigate = useNavigate();
  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-12 py-16">
      <div className="text-center mb-16">
        <p className="text-[#C9A24B] text-xs tracking-[0.3em] uppercase mb-3">Le processus MYSE</p>
        <h1 className="font-serif text-4xl sm:text-5xl text-white">Comment ça marche</h1>
        <p className="text-[#A19E95] mt-4 max-w-2xl mx-auto">
          Réserver une star pour votre événement n'a jamais été aussi simple. Quatre étapes vers un moment inoubliable.
        </p>
      </div>

      <div className="space-y-6">
        {STEPS.map((s, i) => (
          <motion.div
            key={s.num}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            className="flex gap-6 items-start p-6 rounded-2xl border border-white/10 glass hover:border-[#C9A24B]/40 transition"
          >
            <div className="w-14 h-14 shrink-0 rounded-full gold-border flex items-center justify-center text-[#C9A24B]">
              <s.icon size={22} />
            </div>
            <div>
              <span className="font-serif text-2xl gold-text">{s.num}</span>
              <h3 className="font-serif text-2xl text-white mt-1">{s.title}</h3>
              <p className="text-[#A19E95] mt-2 leading-relaxed">{s.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>

      <div className="text-center mt-16">
        <Button onClick={() => navigate("/artistes")} className="gold-bg text-black font-semibold rounded-full px-10 py-6 hover:opacity-90">
          Découvrir les artistes
        </Button>
      </div>
    </div>
  );
}
